import PropTypes from 'prop-types';

// TODO: Potentially move this to reuse RichText instead
const ResourceGroup = ({ items, title }) => {
	return (
		<section className="faq__wrap faq-page-section">
			<div className="faq__container">
				<h2 className="faq__container-title">{title}</h2>
				<div className="faq-page-section__content">
					<p
						className="typography typography--subtle-big typography--secondary"
						dangerouslySetInnerHTML={{
							__html: items?.resources[1]?.value?.value,
						}}
					/>
				</div>
			</div>
		</section>
	);
};

ResourceGroup.propTypes = {
	items: PropTypes.shape({
		resources: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.string,
				value: PropTypes.shape({
					value: PropTypes.string,
				}),
			})
		),
	}).isRequired,
	title: PropTypes.string,
};

export default ResourceGroup;
